import React, { useState } from "react"
import { editModeOn, encryptValue, firstLetterCapital, getFromDecreaptLocalStorage, saveInLocalStorage } from "../utilFunctions";
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import { toast } from "react-toastify";
import TextTruncate from "../utilsComponent/textTruncate";
import { REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_ENDPOINT } from "../urls";
import { axiosRequest } from "../service";
import { functionalities, modes } from "../consts";

const UpdateRole = (props) => {
    const {roledetail,roleDataCookie, setOpenDropDown, functionalityName, getRolesdata, getFunctionalityListdata } = props
    const [roleData, setRoleData] = useState(getFromDecreaptLocalStorage("rolemaster"))
    const cmsStatusListCookies = getFromDecreaptLocalStorage("CMSstatusList")

    const updateFunctionality = (id, value, key) => {
        const updatedFunctionality = {}
        if (key === modes.EDIT_MODE && value === 1) {
            updatedFunctionality[modes.VIEW_MODE] = 1
        }
        updatedFunctionality[key] = value;
        let roleDataEncripted = encryptValue(JSON.stringify({ ...roleData, roleFunctionalities: roleData.roleFunctionalities.map(l => l.functionId == id ? { ...l, ...updatedFunctionality } : l) }))
        saveInLocalStorage("rolemaster", roleDataEncripted)   
        setRoleData({ ...roleData, roleFunctionalities: roleData.roleFunctionalities.map(l => l.functionId == id ? { ...l, ...updatedFunctionality } : l) });
    };

    // const sort = (lists) => {
    //     lists.sort(function(a, b) {
    //         return parseFloat(a.role.functionId) - parseFloat(b.functionId);
    //     });
    // }

    const saveRoleData = () => {
        const payload = {
            roleName: roleData.roleName,
            roleDescription: roleData.roleDescription,
            status: Number(roleData.status),
            createdBy: String(roleData.createdBy),
            createdDate: roleData.createdDate,
            modifiedBy: String(roleData.modifiedBy),
            modifiedDate: roleData.modifiedDate,
            roleFunctionalities: roleData.roleFunctionalities
        }
        axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/role/${roleData.roleID}`, payload).then(data => {
            if(roleDataCookie?.userRoleMapping?.roleID === roleData?.roleID){
                axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/role/${roleData.roleID}`).then(functionalitiesData => {
                      const permissionsList = functionalitiesData.data.roleFunctionalities
                      let roleFunctionalitiesEncripted = encryptValue(JSON.stringify(permissionsList))
                      saveInLocalStorage("roleFunctionalities", roleFunctionalitiesEncripted)          
                  }).catch(error => {
                    console.log(error)
                  })
            }
            toast.success("Role Data Updated Successfully")
            getRolesdata()
            getFunctionalityListdata()
            props.navigateToRoleMater()
        }).catch(error => {
            console.log(error)
            toast.error("Something Went Wrong!")
        })
    }

    return (
        <section className="p-4">
            <h5>Role Details</h5>
            <div className="p-4 px-1">
                <div className="d-flex justify-content-between" >
                    <div>
                        <small className="text-secondary">Role ID</small>
                        <h5>{roleData.roleID}</h5>
                    </div>
                    <div>
                        <small className="text-secondary">Role Name</small>
                        <h5>{roleData.roleName}</h5>
                    </div>
                    <div>
                        <small className="text-secondary">Role Description</small>
                        <h5><TextTruncate text={roleData.roleDescription} length={20} /></h5>
                    </div>
                            <div className="form-group col-md-2">
                                <small className="text-secondary">Role Status</small>
                                <Select
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            cursor: 'pointer',
                                        }),
                                        option: (provided) => ({
                                            ...provided,
                                            cursor: 'pointer',
                                        }),
                                    }}
                                    options={cmsStatusListCookies.map((list, index) => {
                                        return { label: firstLetterCapital(list.name), value: list.id }
                                    })}
                                    isDisabled={roleData.roleName === "Admin"}
                                    onChange={(data) => setRoleData({ ...roleData, status: data.value })}
                                    id="exampleInputPassword8"
                                    defaultValue={{ label: firstLetterCapital(String(roleData.status) == "1" ? "Active" : "Inactive"), value: roleData.status }}
                                    classNamePrefix="bg-gray"
                                    placeholder="Select Role Status" />
                            </div>
                </div>
                {
                    roleData.roleFunctionalities && roleData.roleFunctionalities.length > 0 && (

                        <div className="form-group text-secondary pt-4">
                            {/* <small for="exampleFormControlSelect1">Permissions</small> */}
                            <table className="table table-strip mt-3 text-start">
                                <thead>
                                    <tr>
                                        <th scope="col">Functionalities</th>
                                        <th scope="col">View</th>
                                        <th scope="col">Add / Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        roleData.roleFunctionalities && roleData.roleFunctionalities.length > 0 && roleData.roleFunctionalities.map((list, index) => (
                                            // <div className="d-flex justify-content-between w-50 mt-2">
                                            <>
                                                {/* <div> */}
                                                {functionalityName(list) && (
                                                <tr>
                                                    <td>{functionalityName(list)}</td>
                                                    {/* </div> */}
                                                    <td>
                                                        <div>
                                                            <span className="text-secondary pb-1"><Form.Check
                                                                inline
                                                                name="group1"
                                                                type='checkbox'
                                                                className="ms-2"
                                                                onChange={() => updateFunctionality(list.functionId, roleData.roleFunctionalities[index].viewMode == 1 ? 0 : 1, modes.VIEW_MODE)}
                                                                checked={list.viewMode == 1}
                                                                disabled = {list.editMode === 1}
                                                            /></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <span className="text-secondary pb-1"><Form.Check
                                                                inline
                                                                name="group1"
                                                                type='checkbox'
                                                                className="ms-2"
                                                                onChange={() => {
                                                                    updateFunctionality(list.functionId, roleData.roleFunctionalities[index].editMode == 1 ? 0 : 1, modes.EDIT_MODE)
                                                                }}
                                                                checked={list.editMode == 1}
                                                            /></span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                )}
                                                {/* <div>
                                            <span className="text-secondary pb-1 ">Delete <Form.Check
                                                inline
                                                name="group1"
                                                type='checkbox'
                                                className="ms-2"
                                                onChange={() => updateFunctionality(list.functionId, roleData.roleFunctionalities[index].deleteMode == 1 ? 0 : 1, "deleteMode")}
                                                checked={list.deleteMode == 1 ? true : false}
                                            /></span>
                                        </div> */}
                                            {/* </div> */}
                                            </>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    )
                }
                 {editModeOn(functionalities.ROLE_MASTER_TAB) && (
                    <div className="pt-5">
                        <div className="btn btn-success" onClick={() => { setOpenDropDown(false); saveRoleData() }}>Submit</div>
                        <div className="btn btn-outline-success ms-4" onClick={() => { props.navigateToRoleMater(); setOpenDropDown(false) }}>Cancel</div>
                    
                    </div>
                )}
            </div>
        </section >
    )
};

export default UpdateRole;